import {getConfig} from '@requests/config';
import {
    CLIENT_ID_CONFIG,
    VUZ_ID_CONFIG,
    API_DOMAIN_AUTH_CONFIG,
    API_DOMAIN_VIKON_CONFIG,
    API_DOMAIN_FILEMANAGER_CONFIG,
    VUZ_NAME_CONFIG,
} from '../store/actionTypes';

export function setConfig() {
    return async (dispatch) => {
        const config = await getConfig();
        if (config) {
            await dispatch(clientIdConfig(config.client_id));
            await dispatch(vuzIdConfig(config.vuz_id));
            await dispatch(apiDomainAuthConfig(config.api_domain_auth));
            await dispatch(apiDomainVikonConfig(config.api_domain_vikon));
            await dispatch(apiDomainFilemanagerConfig(config.api_domain_filemanager));
            await dispatch(vuzNameConfig(config.vuz_name));
        }
    };
}
export function clientIdConfig(id) {
    return {
        type: CLIENT_ID_CONFIG,
        id,
    };
}
export function vuzIdConfig(id) {
    return {
        type: VUZ_ID_CONFIG,
        id,
    };
}
export function apiDomainAuthConfig(url) {
    return {
        type: API_DOMAIN_AUTH_CONFIG,
        url,
    };
}
export function apiDomainVikonConfig(url) {
    return {
        type: API_DOMAIN_VIKON_CONFIG,
        url,
    };
}
export function apiDomainFilemanagerConfig(url) {
    return {
        type: API_DOMAIN_FILEMANAGER_CONFIG,
        url,
    };
}
export function vuzNameConfig(value) {
    return {
        type: VUZ_NAME_CONFIG,
        value,
    };
}
